import React, { useEffect, useMemo } from 'react';
import { Form } from 'antd';
import { toCurrency } from 'utils/utils';
import { shouldUpdateCompare } from 'utils/utils2';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  CiLateChargeResponse,
  getLateChargeByCiid,
} from 'services/clientInvoice';
import Title from 'components/Title';
import { useForm } from 'antd/lib/form/Form';
import { useQuery } from 'react-query';
import ModalControllerNV from 'components/ModalControllerNV';
import LateChargeListModal from './ciLateChargeDetailListModal';
import CIDetail from '..';

type TabClientInvoiceLateChargeProps = {
  ciid: number | undefined;
  type?: string;
};

const TabClientInvoiceLateCharge = (props: TabClientInvoiceLateChargeProps) => {
  const { ciid, type } = props;
  const fieldName = 'cilatecharge';
  const [form] = useForm();
  const { data: lateCharge,refetch } = useQuery(
    ['getLateChargeByCiid', ciid],
    () =>
      getLateChargeByCiid({ ciid: Number(ciid) }).then((res) => {
        return res.list.filter((e) => e.calculatedamount > 0) || [];
      }),
    { enabled: !!ciid }
  );
  useEffect(() => {
    refetch();
    if (lateCharge) {
      form.setFieldsValue({
        [fieldName]: lateCharge,
      });
    }
  }, [form, lateCharge,refetch]);

  const columns = useMemo<DataGridColDef<CiLateChargeResponse>[]>(
    () => [
      {
        dataIndex: 'caldate',
        width: '100px',
        render: (value, record, index) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <LateChargeListModal
                  visible={visible}
                  list={record.ciLateChargeDetailList}
                  onCancel={() => setVisible(false)}
                  currcode={record.currcode}
                />
              )}
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
            />
          );
        },
      },
      {
        dataIndex: 'calculatedamount',
        width: '100px',
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'cidueamount',
        width: '100px',
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'cilatechargereference',
        width: '100px',
        render: (val, record) => {
          return type === 'LATEINT' ? (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <CIDetail
                  ciid={record.ciid}
                  onCancel={() => setVisible(false)}
                  showAsModal
                  visible={visible}
                  showButtons={false}
                />
              )}
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>{val}</a>
              )}
            />
          ) : (
            ''
          );
        },
      },
      {
        dataIndex: 'cilatechargereferenceciid',
        width: '100px',
        render: (val, record) =>
          type !== 'LATEINT' ? (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <CIDetail
                  ciid={record.ciidlatecharge}
                  onCancel={() => setVisible(false)}
                  showAsModal
                  visible={visible}
                  showButtons={false}
                />
              )}
              content={({ setVisible, visible }) => (
                <a onClick={() => setVisible(true)}>{record.cilatechargereference}</a>
              )}
            />
          ) : (
            ''
          ),
      },
    ],

    []
  );

  return (
    <div style={{ backgroundColor: '#f7f7f7', padding: 5 }}>
      <Title comcode="LateCharge" level={5}></Title>
      <Form.Item
        noStyle
        shouldUpdate={shouldUpdateCompare('clientInvoiceSchedules')}
      >
        {({ getFieldValue }) => (
          <DataGrid
            columns={columns}
            dataSource={lateCharge}
            rowKey="cisid"
            scroll={{ x: 1200, y: 360 }}
            hideFilters
          />
        )}
      </Form.Item>
    </div>
  );
};

export default TabClientInvoiceLateCharge;
